import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { PageTitle, Sel } from "../../components/Common";

const device = (ua) => {
  if (!ua) return "—";
  const os = /Android/i.test(ua) ? "Android" : /iPhone|iPad/i.test(ua) ? "iOS" : /Windows/i.test(ua) ? "Windows" : /Mac/i.test(ua) ? "Mac" : /Linux/i.test(ua) ? "Linux" : "";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox" : /Safari\//.test(ua) ? "Safari" : "";
  return [br, os].filter(Boolean).join(" · ") || ua.slice(0, 40);
};

export default function LoginActivity() {
  const { t } = useLang();
  const [users, setUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [userId, setUserId] = useState("");
  const [result, setResult] = useState("");
  useEffect(() => { api.get("/users").then((r) => setUsers(r.data)); }, []);
  useEffect(() => {
    const params = {};
    if (userId) params.user_id = userId;
    if (result) params.success = result === "ok";
    api.get("/login-events", { params }).then((r) => setRows(r.data));
  }, [userId, result]);

  return (
    <div data-testid="login-activity-page">
      <PageTitle>{t("login_activity")}</PageTitle>
      <div className="card p-4 mb-4 grid sm:grid-cols-2 gap-3 max-w-2xl">
        <Sel label={t("username")} value={userId} onChange={setUserId} placeholder={t("all_users")}
          options={users.map((u) => ({ id: u.id, name: `${u.username} · ${u.full_name}` }))} testid="login-activity-user-filter" />
        <Sel label={t("la_result")} value={result} onChange={setResult} placeholder={t("all_results")}
          options={[{ id: "ok", name: t("login_ok") }, { id: "fail", name: t("login_failed") }]} testid="login-activity-result-filter" />
      </div>
      <p className="text-xs text-slate-500 mb-2">{t("login_activity_hint")}</p>
      <div className="card overflow-x-auto">
        <table className="tbl w-full" data-testid="login-activity-table">
          <thead><tr><th>{t("la_when")}</th><th>{t("username")}</th><th>{t("la_result")}</th><th>{t("la_device")}</th><th>IP</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="text-slate-500" data-testid="login-activity-empty">{t("none")}</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`login-event-${r.id}`}>
                <td className="font-mono text-xs whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
                <td className="font-mono font-bold">{r.username}{!r.user_id && <span className="ml-2 text-[10px] font-bold bg-slate-200 px-1.5 rounded">{t("unknown_user")}</span>}</td>
                <td><span className={`text-xs font-bold px-2 py-0.5 rounded ${r.success ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-800"}`}>{t(`login_reason_${r.reason}`)}</span></td>
                <td className="text-xs">{device(r.user_agent)}</td>
                <td className="font-mono text-xs">{r.ip || "—"}</td>
              </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
